import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const DocumentIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <g fill="none" stroke={props.nativeColor} strokeLinecap="round" strokeLinejoin="round">
                <line x1="6.5" y1="11.5" x2="16.5" y2="11.5"/>
                <line x1="6.5" y1="8.5" x2="16.5" y2="8.5"/>
                <line x1="6.5" y1="8.5" x2="16.5" y2="8.5"/>
                <line x1="6.5" y1="11.5" x2="16.5" y2="11.5"/>
                <line x1="6.5" y1="17.5" x2="11.5" y2="17.5"/>
                <line x1="6.5" y1="14.5" x2="16.5" y2="14.5"/>
                <path d="M17.5,23.5h-14v-23H16L20.5,5v16"/>
                <path d="M16.5,0.5L16.5,5.5h4.5"/>
            </g>
        </SvgRoot>
    );
};

export default DocumentIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/DocumentIcon.tsx